import React from "react";

import Header from "../general/Header";
import Aside from "../general/Aside";
import Footer from "../general/Footer";
import axios from '../../axios/axiosconf';
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Loading from "../general/Loading";

function Estadisticas() {

    const [loggedIn, setLoggedIn] = useState(false);
    const [client, setClient] = useState([]);
    let userdata = [];
    let clientData = [];

    useEffect(()=>{

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            }
        }

        axios.get('/get-client', config)
            .then(response => {
                if (response.status===200) {
                    
                    setClient(response.data);
                    setLoggedIn(true);
                }
            })
            .catch(error => {
                
                console.log(error);
            });
    },[]);

    if (loggedIn) {
        return (
            
            <div className="hold-transition">
                <Header client={client} />
                <Aside client={client} activelink="reports" />
                
                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-12">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item"><Link to="/home">Home</Link></li>
                                        <li className="breadcrumb-item">Reportes</li>
                                    </ol>
                                </div>
                            </div>
                            <div className="row mb-2">
                                <div className="col-sm-12">
                                    <h1 className="m-0">Reportes</h1>
                                </div>
                            </div>
                        </div>
                    </div>
                    <section className="content" >
                        <div className="container-fluid">

                            
                            <div className="row">
                                <div className="col-md-12 btn-settings-container">
                                    
                                    <Link to={'estadisticas-agenda'} className="btn-settings">
                                        Agenda
                                    </Link>

                                    <Link to={'reporte-pacientes'} className="btn-settings">
                                        Pacientes
                                    </Link>

                                    <Link to={'reporte-facturacion'} className="btn-settings">
                                        Facturación
                                    </Link>

                                    <Link to={'libro-diario'} className="btn-settings">
                                        Libro Diario
                                    </Link>

                                    <Link to={'facturas-recibos'} className="btn-settings">
                                        Facturas vs Recibos
                                    </Link>

                                    <Link to={'documentos-egresos'} className="btn-settings">
                                        Documentos vs Egresos
                                    </Link>

                                </div>          
                            </div>

                        </div>
                    </section>
                </div>
                <Footer showToast={false} delay={0} />
            </div>
            
        );
    }

    return (
        <Loading />
    );
}
export default Estadisticas;